import React, { useState } from 'react';
import ProfileModal from '.././Layout/Components/ProfileModal';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';
import { toJalaliDate } from '../utils/dateUtils';

const TaskAssignedElement = ({ title, description, status, deadline, assignee_name }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  return (
    <>
      <tr className="border-b border-slate-50 hover:bg-slate-50 transition-colors text-sm">
        <td className="p-4 font-bold text-slate-800">{title}</td>
        <td className="p-4 text-slate-600 text-xs truncate max-w-[200px]">{description}</td>
        <td className="p-4 text-xs text-slate-500">
          <div className="flex items-center gap-1"><FaCalendarAlt /> {toJalaliDate(deadline) || 'بدون تاریخ'}</div>
          {deadline && <div className="flex items-center gap-1 mt-1"><FaClock /> {new Date(deadline).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}</div>}
        </td>
        <td className="p-4">
          <span className={`px-3 py-1 rounded-full text-[10px] font-bold ${
            status === "انجام شده" ? "bg-green-100 text-green-700" :
            status === "در حال انجام" ? "bg-indigo-100 text-indigo-700" :
            "bg-slate-100 text-slate-600"
          }`}>
            {status}
          </span>
        </td>
        <td className="p-4">
          <div
            onClick={() => setIsProfileOpen(true)}
            className="flex items-center gap-2 cursor-pointer group"
          >
            <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-xs font-bold text-indigo-600 border border-slate-200">
              {assignee_name?.charAt(0) || "؟"}
            </div>
            <div className="font-bold text-slate-800 group-hover:text-indigo-600 transition-colors">
              {assignee_name || "نامشخص"}
            </div>
          </div>
        </td>
      </tr>

      {isProfileOpen && (
        <ProfileModal
          user={{ name: assignee_name }}
          isOpen={isProfileOpen}
          onClose={() => setIsProfileOpen(false)}
          canEdit={false}
        />
      )}
    </>
  );
};

export default TaskAssignedElement;